import React from 'react';
import { Box, Typography } from '@mui/material';

const steps = [1, 2, 3, 4, 5];

const CustomStepper = ({ value, onChange }) => {
  return (
    <Box sx={{ width: '100%', px: 2 }}>
      {/* Labels */}
      {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="body2">Low</Typography>
        <Typography variant="body2">High</Typography>
      </Box> */}

      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {steps.map((step, index) => {
          const isActive = step === value;

          return (
            <React.Fragment key={step}>
              {/* Step */}
              <Box
                onClick={() => onChange(step)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  zIndex: 1,
                }}
              >
                <Box
                  sx={{
                    width: isActive ? 40 : 10,
                    height: isActive ? 40 : 10,
                    borderRadius: '50%',
                    backgroundColor: '#8B5E3C',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontWeight: 'bold',
                    transition: 'none',
                  }}
                >
                  {isActive ? step : ''}
                </Box>
              </Box>

              {/* Line */}
              {index !== steps.length - 1 && (
                <Box
                  sx={{
                    flex: 1,
                    height: '6px',
                    backgroundColor: '#e0d6cf',
                    mx: 1,
                    borderRadius: '10px',
                  }}
                />
              )}
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );
};

export default CustomStepper;
